var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form"]
var hoisted2 = ["class", "form-group"]
var hoisted3 = ["for", "name"]
var hoisted4 = ["type", "text", "id", "name", "class", "form-control", "focus", "true", "required", ""]
var hoisted5 = ["class", "form-group"]
var hoisted6 = ["for", "description"]
var hoisted7 = ["id", "description", "class", "form-control input-sm"]
var hoisted8 = ["class", "checkbox"]
var hoisted9 = ["type", "checkbox"]
var hoisted10 = ["type", "button", "class", "btn btn-danger btn-xs pull-right"]
var hoisted11 = ["type", "button", "class", "btn btn-primary btn-xs"]
var __target

module.exports = function description (model, root) {
  elementOpen("form", "09d46220-de1e-40c3-8cf4-4ef38aa6e724", hoisted1)
    elementOpen("div", "04511a47-8ebd-4efb-a211-80897eed100f", hoisted2)
      elementOpen("label", "51744318-238e-4fba-bb65-c6823bb0c010", hoisted3)
        text("Schema Name")
      elementClose("label")
      elementOpen("input", "9f65654c-1168-422a-a80e-cbf631650c1d", hoisted4, "value", model.name, "onchange", function ($event) {
        var $element = this;
      model.name = this.value})
      elementClose("input")
    elementClose("div")
    elementOpen("div", "48b27a0c-98cd-41e6-9294-9da51687c9b1", hoisted5)
      elementOpen("label", "f29d8bd6-be48-4683-b2f5-edd780893cae", hoisted6)
        text("Schema Description")
      elementClose("label")
      elementOpen("textarea", "1a1b4002-f106-402f-89c2-821b429c5030", hoisted7, "value", model.description, "onchange", function ($event) {
        var $element = this;
      model.description = this.value})
      elementClose("textarea")
    elementClose("div")
    elementOpen("div", "91948bf2-0cce-4014-bfd7-0560cc1bfeb9", hoisted8)
      elementOpen("label")
        elementOpen("input", "fed1ae2f-304d-48f4-b596-c1e2b6def2fa", hoisted9, "checked", model.isVirtual, "onchange", function ($event) {
          var $element = this;
        model.isVirtual = this.value}, "disabled", model.isReferenced() ? 'disabled' : null)
        elementClose("input")
        text(" Child Schema \
              ")
      elementClose("label")
    elementClose("div")
    elementOpen("button", "ec6d3d36-ac19-46fc-86c6-c4f589f54099", hoisted10, "onclick", function ($event) {
      var $element = this;
    model.model.removeSchema(model); root.currentItem = model.model}, "disabled", model.isReferenced() ? 'disabled' : null)
      text("Remove schema")
    elementClose("button")
    elementOpen("button", "022d6188-6015-4a7d-9498-91d7caae4b17", hoisted11, "onclick", function ($event) {
      var $element = this;
    root.currentItem = model.keys.addKey()})
      text("Add key")
    elementClose("button")
  elementClose("form")
}
